import { render, staticRenderFns } from "./OrderConfirmationRequestInfoMessage.vue?vue&type=template&id=6d096500&lang=pug"
import script from "./OrderConfirmationRequestInfoMessage.vue?vue&type=script&lang=js"
export * from "./OrderConfirmationRequestInfoMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports